/* Orelle cart drawer: the "You May Also Like" row — chevrons page through
   the cards, a colour dot picks that variant (photo + price), and the round
   plus adds it straight to the cart and re-renders the drawer. */
if (!customElements.get('o2c-recs')) {
  customElements.define('o2c-recs', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-o2c-track]');
      this.prev = this.querySelector('[data-o2c-prev]');
      this.next = this.querySelector('[data-o2c-next]');
      if (!this.track) return;
      const step = () => {
        const card = this.track.querySelector('[data-o2c-card]');
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      };
      this.ends = () => {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      };
      this.prev && this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step() }));
      this.next && this.next.addEventListener('click', () => this.track.scrollBy({ left: step() }));
      this.track.addEventListener('scroll', this.ends, { passive: true });
      requestAnimationFrame(this.ends);

      this.addEventListener('click', (e) => {
        const dot = e.target.closest('[data-o2c-dot]');
        if (dot) return this.pick(dot);
        const add = e.target.closest('[data-o2c-add]');
        if (add) this.add(add);
      });
    }

    pick(dot) {
      const card = dot.closest('[data-o2c-card]');
      card.querySelectorAll('[data-o2c-dot]').forEach((d) => {
        const on = d === dot;
        d.classList.toggle('is-on', on);
        d.setAttribute('aria-checked', on);
      });
      const add = card.querySelector('[data-o2c-add]');
      if (add) add.dataset.id = dot.dataset.id;
      const price = card.querySelector('[data-o2c-price]');
      if (price && dot.dataset.price) price.textContent = dot.dataset.price;
      const img = card.querySelector('[data-o2c-img]');
      if (img && dot.dataset.img) {
        img.removeAttribute('srcset');
        img.src = dot.dataset.img;
      }
    }

    add(btn) {
      const drawer = document.querySelector('cart-drawer');
      btn.classList.add('is-busy');
      fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.id), quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      })
        .then((r) => r.json())
        .then((state) => {
          if (state.status || !state.sections) throw new Error(state.description || 'Could not add');
          if (drawer && drawer.renderContents) drawer.renderContents(state);
        })
        .catch((err) => {
          btn.classList.remove('is-busy');
          const box = document.getElementById('CartDrawer-CartErrors');
          if (box) box.textContent = err.message;
        });
    }
  });
}
